export const WINDOW = {
  SHOW_WINDOW: "cn/Window/SHOW_WINDOW",
  MINIMIZE_WINDOW: "cn/Window/MINIMIZE_WINDOW",
  CLOSE_WINDOW: "cn/Window/CLOSE_WINDOW",
  TOGGLE_MAXIMIZE_WINDOW: "cn/Window/TOGGLE_MAXIMIZE_WINDOW",
  SET_ACTIVE_WINDOW: "cn/Window/ACTIVE_WINDOW",
  MINIMIZE_ALL_EXCEPT: "cn/Window/MINIMIZE_ALL_EXCEPT",
};
